import i18n from '@/utils/i18n';
import React, { useEffect, useMemo } from 'react';
import { Props as NavigationHeaderProps } from '@/components/navigation-header';
import { PageContainer } from '@/components/page-container';
import { SCREEN_PADDING } from '@/styles';
import { StackScreenProps } from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useSmallLayoutSizeValue } from '@/contexts/layout-context';
import { useVolumePromotionsContext } from '@/contexts/volume-promotions-context';
import { VolumePromotionDetailComponent } from '@/components/orders/volume-promotion-detail-component';

export const VolumePromotionDetailScreen = <
  T extends StackScreenProps<
    { VolumePromotionDetail: { promotionUUID: string } },
    'VolumePromotionDetail'
  >,
>({
  navigation,
  route,
}: T) => {
  const { bottom } = useSafeAreaInsets();
  const { promotions } = useVolumePromotionsContext();

  const promotion = useMemo(
    () => promotions.find((p) => p.uuid === route.params.promotionUUID),
    [promotions, route.params.promotionUUID],
  );

  useEffect(() => {
    if (!promotion) {
      navigation.goBack();
    }
  }, [navigation, promotion]);

  const baseNavHeaderProps = useSmallLayoutSizeValue<
    Partial<NavigationHeaderProps>
  >(
    {
      centerTitle: true,
      showBackButton: true,
      title: promotion?.hideTagline ? undefined : promotion?.tagline,
    },
    {
      backButtonLabel: i18n.t('back_to', { name: i18n.t('promotions') }),
      showBackButton: false,
      title: promotion?.hideTagline ? undefined : promotion?.tagline,
    },
  );

  const navigationHeaderProps = useMemo(() => {
    return {
      ...baseNavHeaderProps,
      responsive: true,
    };
  }, [baseNavHeaderProps]);

  return promotion ? (
    <PageContainer navigationHeaderProps={navigationHeaderProps}>
      <VolumePromotionDetailComponent
        listContainerStyle={{ paddingBottom: Math.max(bottom, SCREEN_PADDING) }}
        promotion={promotion}
      />
    </PageContainer>
  ) : null;
};
